module.exports = __webpack_public_path__ + "img/t.31b61347.jpg";